import { CatIconSuccessFilled } from 'components/blocks-components';
import { useTranslations } from 'next-intl';
import cx from 'classnames';

const FullMatchFitment = ({ selectedEquipment, className = '' }) => {
  const t = useTranslations();

  return (
    <p className={cx('d-flex m-0', className)}>
      <CatIconSuccessFilled color="success" className="pe-1" />
      <span className="cat-u-theme-typography-label-sm">
        {t('PART_FACTORY_FIT')} {selectedEquipment?.model}{' '}
        {selectedEquipment?.serialNumber}
      </span>
    </p>
  );
};

export default FullMatchFitment;
